import React from "react";
import { Link as ScrollLink } from "react-scroll";
import {motion} from "framer-motion";

const herosectionData = {
  name: "Hello World",
  aboutMe:
    "Welcome to my world of web wizardry! I'm here to help bring your dream website to life. With a strong foundation in frontend development and a good understanding of UI/UX design, I offer a holistic approach from concept to execution.",
};

function Herosection() {
  return (
    <motion.section
      className="hero background parallax shadow-dark d-flex align-items-center"
      style={{ backgroundImage: "url(/images/hero.jpg.)"  }}
      initial={{x:'-100vw'}}
              animate={{x:0}}
      transition={{delay:1.5, duration:1.5}}
    >
      <div className="cta mx-auto mt-2">
        <h1 className="mt-0 mb-4 cd-words-wrapper">
           {herosectionData.name}
          <span className="dot"></span>
        </h1>
        <p className="mb-4">{herosectionData.aboutMe}</p>
        <ScrollLink
          activeClass="active"
          to="section-portfolios"
          spy={true}
          smooth={true}
          duration={500}
          offset={50}
          className="btn btn-default btn-lg mr-3"
        >
          <i className="icon-grid"></i>View Portfolio
        </ScrollLink>
        <div
          className="spacer d-md-none d-lg-none d-sm-none"
          data-height="10"
        ></div>
        <a href="mailto:adenugaib24@gmail.com">
        <button
          activeClass="active"
          to=""
          spy={true}
          smooth={true}
          duration={500}
          offset={50}
          className="btn btn-border-light btn-lg"
        >
          <i className="icon-envelope"></i>Hire me
        </button>

        </a>
        
      </div>
      <div className="overlay"></div>
    </motion.section>
  );
}

export default Herosection;
